import { c as _c } from "react/compiler-runtime";
import { sanitizeUrl } from "@braintree/sanitize-url";
import { disabledVariants } from "../../styles/utils/disabled";
import { linkVariants } from "../../styles/utils/link";
import { classNames } from "../../utils/classNames";
/**
 * A standard `a` tag with reasonable defaults.
 */
export function Link(t0) {
  const $ = _c(22);
  let className;
  let disabled;
  let href;
  let rel;
  let rest;
  let t1;
  let target;
  if ($[0] !== t0) {
    ({
      className,
      href,
      variant: t1,
      disabled,
      rel,
      target,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = disabled;
    $[3] = href;
    $[4] = rel;
    $[5] = rest;
    $[6] = t1;
    $[7] = target;
  } else {
    className = $[1];
    disabled = $[2];
    href = $[3];
    rel = $[4];
    rest = $[5];
    t1 = $[6];
    target = $[7];
  }
  const variant = t1 === undefined ? "default" : t1;
  if (href && isExternalLink(href)) {
    target = target ?? "_blank";
    rel = rel ?? "nofollow noopener";
  }
  const t2 = disabled ?? undefined;
  let t3;
  if ($[8] !== className || $[9] !== disabled || $[10] !== variant) {
    t3 = classNames(linkVariants({
      variant
    }), disabledVariants({
      disabled
    }), className);
    $[8] = className;
    $[9] = disabled;
    $[10] = variant;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== href) {
    t4 = href ? sanitizeUrl(formatHref(href)) : undefined;
    $[12] = href;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  const t5 = disabled ? -1 : undefined;
  let t6;
  if ($[14] !== rel || $[15] !== rest || $[16] !== t2 || $[17] !== t3 || $[18] !== t4 || $[19] !== t5 || $[20] !== target) {
    t6 = <a aria-disabled={t2} className={t3} href={t4} rel={rel} tabIndex={t5} target={target} {...rest} />;
    $[14] = rel;
    $[15] = rest;
    $[16] = t2;
    $[17] = t3;
    $[18] = t4;
    $[19] = t5;
    $[20] = target;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  return t6;
}
export const isExternalLink = href => {
  if (typeof href === "string") {
    return !href.startsWith("/");
  }
  return !href.pathname.startsWith("/");
};
export const formatHref = href => {
  if (typeof href === "string") {
    return href;
  }
  const querystring = stringifyQuery(href.query);
  if (!querystring) {
    return href.pathname;
  }
  return `${href.pathname}?${querystring}`;
};
const stringifyQuery = query => {
  if (!query) {
    return "";
  }
  const segments = [];
  for (const [key, rawValue] of Object.entries(query)) {
    const encodedKey = encodeURIComponent(key);
    const appendValue = value => {
      let encodedValue = "";
      if (value === null || value === undefined) {
        // noop – encodedValue already empty
      } else if (typeof value === "string") {
        encodedValue = encodeURIComponent(value);
      } else if (typeof value === "number") {
        if (Number.isFinite(value)) {
          encodedValue = encodeURIComponent(String(value));
        }
      } else if (typeof value === "bigint") {
        encodedValue = encodeURIComponent(value.toString());
      } else if (typeof value === "boolean") {
        encodedValue = encodeURIComponent(value ? "true" : "false");
      }
      segments.push(`${encodedKey}=${encodedValue}`);
    };
    if (Array.isArray(rawValue)) {
      if (rawValue.length === 0) {
        continue;
      }
      for (const item of rawValue) {
        appendValue(item);
      }
      continue;
    }
    appendValue(rawValue);
  }
  return segments.join("&");
};
export function NonAnchorLink(t0) {
  const $ = _c(22);
  let className;
  let disabled;
  let href;
  let rest;
  let t1;
  if ($[0] !== t0) {
    ({
      href,
      className,
      disabled,
      variant: t1,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = disabled;
    $[3] = href;
    $[4] = rest;
    $[5] = t1;
  } else {
    className = $[1];
    disabled = $[2];
    href = $[3];
    rest = $[4];
    t1 = $[5];
  }
  const variant = t1 === undefined ? "default" : t1;
  let t2;
  if ($[6] !== href) {
    t2 = function navigate() {
      if (href) {
        if (isExternalLink(href)) {
          window.open(sanitizeUrl(formatHref(href)), "_blank");
        } else {
          window.location.href = sanitizeUrl(formatHref(href));
        }
      }
    };
    $[6] = href;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const navigate = t2;
  let t3;
  if ($[8] !== className || $[9] !== disabled || $[10] !== variant) {
    t3 = classNames(linkVariants({
      variant
    }), disabledVariants({
      disabled
    }), className);
    $[8] = className;
    $[9] = disabled;
    $[10] = variant;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  let t5;
  if ($[12] !== navigate || $[13] !== rest) {
    t4 = event => {
      rest.onClick?.(event);
      event.preventDefault();
      navigate();
    };
    t5 = event_0 => {
      rest.onKeyDown?.(event_0);
      if (event_0.keyCode === 13) {
        navigate();
      }
    };
    $[12] = navigate;
    $[13] = rest;
    $[14] = t4;
    $[15] = t5;
  } else {
    t4 = $[14];
    t5 = $[15];
  }
  const t6 = disabled ? -1 : 0;
  let t7;
  if ($[16] !== rest || $[17] !== t3 || $[18] !== t4 || $[19] !== t5 || $[20] !== t6) {
    t7 = <span {...rest} className={t3} onClick={t4} onKeyDown={t5} role="link" tabIndex={t6} />;
    $[16] = rest;
    $[17] = t3;
    $[18] = t4;
    $[19] = t5;
    $[20] = t6;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  return t7;
}